import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PepEmployment.html?raw';

import PepEmploymentEditor from './PepEmploymentEditor';

import { FeatureHelpers, ToasterHelpers } from "../../../more/Helpers";
import PepRosterTable from '../PepRosterTable';
import { PEP } from "../PepTypes";
//import _PepBase = require("../_PepBase");



class PepEmployment extends compose(_WidgetBaseSP) {
    templateString: any = template;

    isDirty: boolean = false;

    private _data: PEP.EmploymentData = null;
    private _originalData: string = null;
    private _backupData: string = null;
    submitData: PEP.ResultData = null;
    isVirtual: boolean = false;
    isDraft: boolean = false;
    virtualID: string = null;
    isDeleting: boolean = false;
    isBlank: boolean = true;

    causedBy: "user" | "system" = "system";

    txtLabel: HTMLDivElement;
    txtShortLabel: HTMLElement;
    txtShortLabelCompact: HTMLElement;
    txtValue1: HTMLElement;
    txtValue2: HTMLElement;
    editorNode: HTMLDivElement;
    smallValuesContainer: HTMLDivElement;
    bookingStatusContainer: HTMLDivElement;
    txtBookingStatusSymbol: HTMLElement;
    bookingStatusColorStrip: HTMLDivElement;
    notesTooltipContainer: HTMLDivElement;
    notesContainer: HTMLDivElement;
    notesContent: HTMLDivElement;

    editor: MdsLax<InstanceType<typeof PepEmploymentEditor>> = null;//window.PepEmploymentEditor;
    editorActive: boolean = false;

    tableCell: PEP.Cell = null;
    table: MdsLax<InstanceType<typeof PepRosterTable>> = null;

    private windowEx: PEP.WindowEx;

    private _setDataAttr(data) {
        this.setData(data);
    }
    setData(data: PEP.EmploymentData): void {
        this._data = data;

        if (typeof (data.virtual) == "undefined") {
            data.virtual = false;
        }

        if (typeof (data.draft) == "undefined") {
            data.draft = false;
        }

        if (typeof (data.dirty) == "undefined") {
            data.dirty = false;
        }

        this.isVirtual = this._data == null || this._data.virtual == true;

        if (this.isVirtual != true && this._originalData == null) {
            this._originalData = JSON.stringify(this._data);
        }

        //console.debug("employment _setDataAttr", this.isVirtual, this._data);
        //this.applyData();
    }

    private _setTableCellAttr(cell: PEP.Cell) {
        this.tableCell = cell;

        if (cell != null) {
            this.table = cell.table;
        }
    }

    getData(): PEP.EmploymentData {
        return this._data;
    }
    private _getDataAttr(): PEP.EmploymentData {
        return this.getData();
    }

    private getEmploymentTypeById(employmentTypeId: string): PEP.EmploymentType {
        if (employmentTypeId) return this.windowEx.PepRegistry.employmentTypes[employmentTypeId];

        //console.debug("getEmploymentTypeById", employmentTypeId, this.windowEx.PepRegistry.employmentTypes);
        //for (let _employmentType of this.windowEx.PepRegistry.employmentTypes) {
        //    if (_employmentType.ID == employmentTypeId) {
        //        return _employmentType;
        //    }
        //}

        return null;
    }

    private getBookingStatusById(statusId: string): PEP.EmploymentBookingStatus {
        if (statusId) return this.windowEx.PepRegistry.employmentBookingStatus[statusId];

        //console.debug("getEmploymentTypeById", employmentTypeId, this.windowEx.PepRegistry.employmentTypes);
        //for (let _bookingStatus of this.windowEx.PepRegistry.employmentBookingStatus) {
        //    if (_bookingStatus.ID == statusId) {
        //        return _bookingStatus;
        //    }
        //}

        return null;
    }

    applyData(newData?: PEP.EmploymentData): void {

        if (typeof (newData) != "undefined") {
            this.setData(newData);
            //return; // via set kommt eh das Apply daher....
        }

        //console.debug("employment applyData", this._data);

        this.UiModder.domClass.remove(this.domNode, "editable");

        this.UiModder.domClass.remove(this.domNode, "blank employment");

        if (this._data == null) {
            this.isBlank = true;
            this.UiModder.domClass.add(this.domNode, "blank");

            return;
        }

        this.isBlank = false;
        this.UiModder.domClass.add(this.domNode, "employment");
        this.UiModder.domClass.remove(this.txtShortLabelCompact, "dutyAsterisk");
        this.UiModder.domClass.remove(this.txtLabel, "dutyAsterisk");

        let data = this._data;

        let taskDefinition: PEP.TaskDefinition = null;
        let employmentType: PEP.EmploymentType = this.windowEx.CurrentSelectedEmploymentTypeTemplate;
        let employmentDescription = "";
        let employmentShortLabel = this._data.shortLabel;
        let employmentShortLabelCompact = this._data.shortLabelCompact;
        let value1 = "?";
        let value2 = "?";
        let bookingStatusSymbol: string = "?";
        let bookingStatusColorBG: string = "";
        let bookingStatusColorTXT: string = "";
        let bookingStatusTooltip: string = "";
        let mainColorTXT: string = data.mainColorationTXT;

        if (this._data.is_on_duty === true) {
            this.UiModder.domClass.add(this.txtShortLabelCompact, "dutyAsterisk");
            this.UiModder.domClass.add(this.txtLabel, "dutyAsterisk");
        }

        if (data.ref_task_definition) {
            taskDefinition = this.windowEx.PepRegistry.taskDefinitions[data.ref_task_definition];
        }

        this.UiModder.domClass.toggle(this.domNode, "warning", !!data.note_warnings);

        //for (let _taskDefinition of this.windowEx.PepRegistry.taskDefinitions) {
        //    if (_taskDefinition.ID == data.ref_task_definition) {
        //        taskDefinition = _taskDefinition;
        //        //BGColor = taskDefinition.coloration.BackColor.Hex;
        //        break;
        //    }
        //}

        // Labels überschreiben, weil.... ?
        //let _employmentType = this.getEmploymentTypeById(data.ref_type);
        //if (_employmentType != null) {
        //    employmentType = _employmentType;
        //    employmentShortLabel = employmentType.code;
        //    employmentDescription = employmentType.description;
        //} 

        let _bookingStatus = this.getBookingStatusById(data.ref_empl_booking_status);

        if (_bookingStatus != null) {
            bookingStatusSymbol = _bookingStatus.symbol;
            bookingStatusTooltip = _bookingStatus.description;
            if (_bookingStatus.coloration.BackColor.IsNull != true) {
                bookingStatusColorBG = _bookingStatus.coloration.BackColor.Hex;
            }

            if (_bookingStatus.coloration.TextColor.IsNull != true) {
                bookingStatusColorTXT = _bookingStatus.coloration.TextColor.Hex;
            }

        }

        if (this.isVirtual == true) {

        }

        this.isDeleting = data.deleting;


        this.txtShortLabel.innerHTML = employmentShortLabel;
        this.txtShortLabelCompact.innerHTML = employmentShortLabelCompact;
        this.txtLabel.innerHTML = data.mainLabel;
        this.txtValue1.innerHTML = data.value1;
        this.txtValue2.innerHTML = data.value2;
        //this.UiModder.domStyle.set(this.domNode, "backgroundColor", data.mainColorationBG);

        this.domNode.style.setProperty("--colorBG", data.mainColorationBG);
        this.domNode.style.setProperty("--colorTXT", data.mainColorationTXT);

        //this.UiModder.domStyle.set(this.txtLabel, "color", mainColorTXT);
        //this.UiModder.domStyle.set(this.txtShortLabel, "color", mainColorTXT);
        //this.UiModder.domStyle.set(this.txtShortLabelCompact, "color", mainColorTXT);


        this.UiModder.domAttr.set(this.txtShortLabel, "title", employmentDescription);
        this.UiModder.domAttr.set(this.txtShortLabelCompact, "title", employmentDescription);

        this.txtBookingStatusSymbol.innerHTML = bookingStatusSymbol;
        this.UiModder.domStyle.set(this.bookingStatusContainer, "backgroundColor", "");
        this.UiModder.domStyle.set(this.bookingStatusColorStrip, "backgroundColor", bookingStatusColorBG);
        this.UiModder.domStyle.set(this.bookingStatusColorStrip, "border", bookingStatusColorTXT != "" ? this.stringFormat("1px solid {0}", bookingStatusColorTXT) : "");
        this.UiModder.domAttr.set(this.bookingStatusColorStrip, "title", bookingStatusTooltip);
        this.UiModder.domAttr.set(this.bookingStatusContainer, "title", bookingStatusTooltip);
        this.UiModder.domStyle.set(this.bookingStatusContainer, "color", "");


        //if (data.notes == "" || data.notes == null) {
        let notes = "";
        if (this.tableCell.infoData?.dayRecordInfo) {
            for (let note of this.tableCell.infoData.dayRecordInfo.notes) { // blödes Format: das Array ist eigentlich nur ein Eintrag für Tagesanmerkung.
                notes += note;
                break;
            }
        }

        if (notes) {
            this.UiModder.domClass.add(this.notesTooltipContainer, "w3-hide");
            this.UiModder.domClass.add(this.notesContainer, "w3-hide");
            this.UiModder.domAttr.set(this.notesTooltipContainer, "title", "");
            this.UiModder.domAttr.set(this.notesContent, "innerHTML", "");
        } else {
            //this.UiModder.domClass.remove(this.notesContainer, "w3-hide");
            //this.UiModder.domClass.remove(this.notesTooltipContainer, "w3-hide");
            //this.UiModder.domAttr.set(this.notesTooltipContainer, "title", data.notes);
            //this.UiModder.domAttr.set(this.notesContent, "innerHTML", data.notes);
        }

        if (data.locked != true) {
            this.UiModder.domClass.add(this.domNode, "editable");
        } else {
            this.UiModder.domClass.add(this.domNode, "locked");
        }


        if (this.isVirtual == true) {
            this.UiModder.domClass.add(this.domNode, "virtual");
            //this.showEditor(); // zu früh!!
        }

        if (this.editorActive == true) {
            this.table.recalcRowHeights(this.tableCell.row);
        }

        // PINSELMODUS
        if (this.causedBy == "user") {

            this.causedBy = "system"; // zurücksetzen auf Standard
        }
    }

    applyTemplate(template?: PEP.EmploymentTemplate): PEP.EmploymentData {

        if (typeof (template) == "undefined") {
            template = this.windowEx.CurrentSelectedEmploymentTypeTemplate;
        }

        let cell = this.tableCell;

        if (template == null &&
            this.windowEx.CurrentSelectedClickMode != PEP.ClickMode.create &&
            this.windowEx.CurrentSelectedClickMode != PEP.ClickMode.default) {
            console.warn("can't apply empty template with this clickmode", this.windowEx.CurrentSelectedClickMode, template, cell);
            return;
        }

        if (cell.locked === true) {
            console.warn("can't apply template to locked cell", cell, template);
            this.showToast({
                title: "PEP_warning_lockedCell",
                options: {
                    ID: "lockedCell",
                    timeout: 4000
                },
                iconClass: ToasterHelpers.ToasterIcons.warning
            });
            return;
        }

        this.isVirtual = this._data == null || this._data.virtual === true;

        let currentID: string = null;
        if (this.isVirtual != true) {
            currentID = this._data.ID;
        }
        else {
            currentID = this.virtualID;
        }

        let bookingStatus: string = this.windowEx.PepRegistry.defaultEmploymentBookingStatus;
        if (template != null) {
            if (template.ref_empl_booking_status != "" && template.ref_empl_booking_status != null) {
                bookingStatus = template.ref_empl_booking_status;
            }
        }

        let cu1 = null;
        let cu2 = null;
        let cu3 = null;


        let useCostUnits = FeatureHelpers.hasFeature("PEP/useCostUnits");


        if (template && useCostUnits == true) {
            if (template.costUnit1) {
                cu1 = { ID: template.costUnit1.ID, code: template.costUnit1.code };
            }
            if (template.costUnit2) {
                cu2 = { ID: template.costUnit2.ID, code: template.costUnit2.code };
            }
            if (template.costUnit3) {
                cu3 = { ID: template.costUnit3.ID, code: template.costUnit3.code };
            }
        }

        //console.debug("employment applyTemplate", cell, template);
        let notes = "";
        if (cell.infoData?.dayRecordInfo) {
            for (let note of cell.infoData.dayRecordInfo.notes) { // blödes Format: das Array ist eigentlich nur ein Eintrag für Tagesanmerkung.
                notes += note;
                break;
            }
        }

        let tempData: PEP.EmploymentData = {
            Classname: null,
            duration: null,
            duration_pause: template != null ? template.pause_duration_default : null,
            duration_payed: null,
            end: null,
            endTXT: template != null ? template.endTXT : null,
            ID: currentID,
            is_pause_payed: null,
            is_on_duty: template != null ? template.is_on_duty : false,
            is_no_break: template?.is_no_break === true,
            locked: cell.locked,
            EditEmplBookingStatus: true,
            mainColorationBG: "",
            mainColorationTXT: "",
            mainLabel: template != null ? template.mainLabel : null,
            shortLabel: template != null ? template.code : "",
            shortLabelCompact: template != null ? template.code : "",
            ref_empl_booking_status: bookingStatus,
            ref_day: cell.xID,
            ref_task_definition: null,
            ref_type: template != null ? template.ID : null,
            start: null,
            startTXT: template != null ? template.startTXT : null,
            pauseTXT: template != null ? typeof (template.pause_duration_default) == "number" ? template.pause_duration_default.toFixed(2) : null : null,
            value1: null,
            value2: null,
            xID: cell.xID,
            yID: cell.yID,
            date: null,
            label: null,
            virtual: this.isVirtual,
            draft: this.isDraft,
            dirty: false,
            is_oversteered_time: false,
            is_oversteered_duration: false,
            //notes: notes,
            ref_cost_unit_1: cu1,
            ref_cost_unit_2: cu2,
            ref_cost_unit_3: cu3,
            date_time_confirmed_at: null,
            EditIsTimeConfirmed: false,
            is_times_confirmed: false,
            times_confirmed_by: null
        };

        if (FeatureHelpers.hasFeature("PEP/useMultipleBreaks")) {
            tempData.breaks = [];
            if (template && template.breaks?.length) {
                for (let brk of template.breaks) {
                    tempData.breaks.push({
                        ...brk
                    });
                }
            }
        }

        //this.set("data", tempData);
        this.setData(tempData);
        cell.employmentData.push(tempData);

        this.startup();

        if (this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.brush ||
            this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.brushCreate ||
            this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.delete) {

            let data = this._data;

            let saveData: PEP.ResultData = {
                mode: this.isVirtual == true ? PEP.SubmitEntryMode.create : PEP.SubmitEntryMode.change,
                //node: this.domNode,
                editedData: {
                    employmentTypeID: data.ref_type,
                    bookingStatusID: data.ref_empl_booking_status,
                    costUnit1ID: data.ref_cost_unit_1 != null ? data.ref_cost_unit_1.ID : null,
                    costUnit2ID: data.ref_cost_unit_2 != null ? data.ref_cost_unit_2.ID : null,
                    costUnit3ID: data.ref_cost_unit_3 != null ? data.ref_cost_unit_3.ID : null,
                    ID: data.ID,
                    is_oversteered_duration: data.is_oversteered_duration,
                    is_oversteered_time: data.is_oversteered_time,
                    is_on_duty: data.is_on_duty,
                    is_no_break: data.is_no_break === true,
                    taskDefinitionID: data.ref_task_definition,
                    xID: data.xID,
                    yID: data.yID,
                    end: data.end,
                    start: data.start,
                    endTXT: data.endTXT,
                    startTXT: data.startTXT,
                    pauseTXT: data.pauseTXT,
                    mainLabel: data.mainLabel,
                    shortLabel: data.shortLabel,
                    warningMessage: data.note_warnings,
                    //notes: notes, // aus der Tagesbasis, nicht vom Dienst,
                    is_times_confirmed: data.is_times_confirmed
                }
            };

            if (this.hasFeature("PEP/useMultipleBreaks")) {
                saveData.editedData.breaks = lang.clone(data.breaks);

            }

            if (!this.isVirtual && this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.delete) {
                saveData.mode = PEP.SubmitEntryMode.delete;
            }
            this.confirmNewData(saveData);
        } else {

        }

        return tempData;
    }

    private _onClick_Employment(evt: MouseEvent) {
        //console.debug("onclick_employment");
        if (this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.create) {
            // hochbubbeln lassen zur Table-Cell: die übernimmt das als "neuer Eintrag erzeugen"
            return;
        }

        
        if (this._data == null) {
            return;
        }
        if (this._data.locked == true) {
            this.showEditor();
            evt.stopPropagation();
            return;
        }


        evt.stopPropagation();

        // ist das geklickselte Employment schon dirty, also fürs Löschen oder Ändern markiert?
        if (this.isDeleting === true) {


        }

        if (this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.delete) {
            if (this.isVirtual === true) {
                this.confirmNewData(this.submitData, true);
                return;
            }

            let saveData: PEP.ResultData = {
                mode: PEP.SubmitEntryMode.delete,
                //node: this.domNode,
                editedData: {
                    xID: this._data.xID,
                    yID: this._data.yID,
                    ID: this._data.ID,
                    bookingStatusID: null,
                    costUnit1ID: null,
                    costUnit2ID: null,
                    costUnit3ID: null,
                    employmentTypeID: null,
                    is_oversteered_duration: null,
                    is_on_duty: false,
                    is_no_break: false,
                    is_oversteered_time: null,
                    //notes: null,
                    pauseTXT: null,
                    taskDefinitionID: null,
                    end: null,
                    endTXT: null,
                    start: null,
                    startTXT: null,
                    shortLabel: null,
                    mainLabel: null,
                    warningMessage: null,
                    is_times_confirmed: false
                }
            };

            this.confirmNewData(saveData);

            return;
        }


        if (this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.brush) {
            this.applyTemplate();
            return;
        }


        this.showEditor();
    }

    private _onClick_Blank(evt: MouseEvent) {

    }

    private _editorChangeHandle: dojo.Handle;
    private _editorUpdateHandle: dojo.Handle;
    showEditor(target?: "editor" | "entityview" | "previous") {

        this.editor = this.windowEx.PepEmploymentEditor;
        
        if (!this.editor || this.editor._destroyed) {
            this.windowEx.PepEmploymentEditor = new PepEmploymentEditor();
            this.editor = this.windowEx.PepEmploymentEditor;
        }
        this._backupData = JSON.stringify(this._data);
        //console.debug("employment showEditor", this._data);

        this.table.closeDayRecordInfoContainer();

        this.editor.closeAndSubmit(); // falls der bereits wo offen ist löst er damit die Response aus...

        // jetzt zu mir herholen:
        this.UiModder.domConstruct.place(this.editor.domNode, this.editorNode);

        // und wir sind live:
        this.editorActive = true;
        this.UiModder.domClass.add(this.domNode, "editing");
        this.UiModder.domClass.add(this.tableCell.node, "editing");
        this.UiModder.domClass.add(this.tableCell.column.headerNode.domNode, "editing");
        this.UiModder.domClass.add(this.tableCell.row.headerNode, "editing");
        this.UiModder.domClass.add(this.tableCell.row.node, "editing");
        //this.UiModder.domClass.add(this.table.domNode, "w3-grayscale");

        // die vorgekauten Editordaten aus dem letzten Durchlauf mitgeben!

        this.editor.show(this._data, lang.hitch(this, this.onEditorResponse), this.tableCell, this.submitData?.editedData, false, target);

        if (this._data.locked) {
            this.editor.setReadonly(true);
        } else {
            this.editor.setReadonly(false);
            if (this._editorChangeHandle) this._editorChangeHandle.remove();
            this._editorChangeHandle = on(this.editor, "change", lang.hitch(this, this.onEditorDataChange));
            this._editorUpdateHandle = on(this.editor, "update", lang.hitch(this, this.onEditorUpdate));
        }
        if (this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.default || this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.create) {
            if (this.isVirtual) {
                this.editor.domNode.scrollIntoView({ behavior: "smooth", block: "end" });
            }
        }

        // #24241 prüfen ob das Editorfenster außerhalb des sichtbaren Bereichs liegt (ganz rechts in Tabelle)
        let rect = this.editor.domNode.getBoundingClientRect();
        let rectTable = this.table.domNode.getBoundingClientRect();

        if (rect.right > this.windowEx.innerWidth) {
            this._tempScrollAmount = rect.right - this.windowEx.innerWidth;
            this.editor.domNode.scrollIntoView({ behavior: "smooth", block: "end" });
        } else if (rect.bottom > rectTable.height) {
            this.editor.domNode.scrollIntoView({ behavior: "smooth", block: "end" });
        }

    }
    private _tempScrollAmount: number = 0;

    private confirmNewData(newData: PEP.ResultData, bRollback?: boolean): void {

        this.UiModder.domClass.remove(this.domNode, "dirty changing creating deleting virtual");

        if (bRollback !== true) {
            let styleClass = "changing";
            this.isDeleting = false;
            this.isDraft = false;

            this.submitData = lang.clone(newData);

            //let currentData = this._data as object;
            //for (let key in newData) {
            //    if ((currentData as any).hasOwnProperty(key)) {
            //        currentData[key] = lang.clone(newData[key]);
            //    }
            //}

            this._data.draft = false;
            this._data.dirty = true;
            this._data.deleting = false;

            switch (newData.mode) {
                case PEP.SubmitEntryMode.create:
                    styleClass = "creating";
                    this.isVirtual = true;
                    break;

                case PEP.SubmitEntryMode.delete:
                    styleClass = "deleting";
                    this.isDeleting = true;
                    this._data.deleting = true;
                    break;

                case PEP.SubmitEntryMode.change:
                default:
                    styleClass = "changing";
                    break;
            }

            this.UiModder.domClass.add(this.domNode, styleClass);

            this.UiModder.domClass.add(this.domNode, "dirty");
            this.UiModder.domClass.remove(this.tableCell.employmentsNode, "emptyCreateClick");

            this.table.addToSubmitQueue(this);

        } else {
            this._data.dirty = false;

            if (this.isVirtual == true) {
                // mich selbst zerstören, weil ich werd nicht mehr gebraucht und bin ja nicht wirklich in der DB
                this.UiModder.domClass.add(this.domNode, "w3-hide");
                this.table.recalcRowHeights(this.tableCell.row);
                //this.destroy(); // achtung: wenn der editor dranhängt, dann wird der mitdestroyed.
                if (this.editorActive == true) {
                    this.UiModder.domConstruct.place(this.editor.domNode, document.body);
                }
                this.table.removeFromSubmitQueue(this);
                //setTimeout(lang.hitch(this, this.destroy), 20);
            } else {
                if (this._originalData != null) {
                    this.applyData(JSON.parse(this._originalData));
                }
            }

            if (this.submitData) {
                this.submitData = null;
            }

            if (this.isDraft != true && this.isVirtual != true) {
                this.table.removeFromSubmitQueue(this);
            }
        }
    }

    private onEditorResponse(result: number, newData: PEP.ResultData) {
        console.log("onEditorResponse", result, newData, "editor draft? " + this.editor["isDraft"], "employment draft? " + this.isDraft);

        if (this._editorChangeHandle) {
            this._editorChangeHandle.remove();
            this._editorChangeHandle = null;
        }

        if (this._editorUpdateHandle) {
            this._editorUpdateHandle.remove();
            this._editorUpdateHandle = null;
        }

        if (this.editorActive != true) {
            return;
        }

        this.UiModder.domClass.remove(this.domNode, "editing");
        this.UiModder.domClass.remove(this.tableCell.node, "editing");
        this.UiModder.domClass.remove(this.tableCell.row.headerNode, "editing");
        this.UiModder.domClass.remove(this.tableCell.row.node, "editing");
        this.UiModder.domClass.remove(this.tableCell.column.headerNode.domNode, "editing");
        this.UiModder.domClass.remove(this.tableCell.employmentsNode, "creating");
        //this.UiModder.domClass.remove(this.table.domNode, "w3-grayscale");

        if (this._tempScrollAmount > 0) { // #24241

            window.scrollBy(this._tempScrollAmount * -1, 0);
            this._tempScrollAmount = 0;
        }

        if (result == 1) {
            //newData.node = this.domNode;
            this.confirmNewData(newData);
        } else if (result == -1) {
            this.confirmNewData(newData, true);
        } else {

            // wenn der Datensatz noch ein Entwurf ist (virtuell, nicht bestätigt...) dann kann er rollbacked werden.
            if (this.isDraft == true) {
                this.confirmNewData(newData, true);
            } else {
                this.applyData(JSON.parse(this._backupData));
            }
        }

        this.editorActive = false;
    }

    private onEditorUpdate(): void {
        this.emit("update");
    }

    private onEditorDataChange(changeData?: PEP.EditorData): void {
        if (this.editorActive != true || !changeData) {
            return;
        }
        let data = this._data;

        data.endTXT = changeData.endTXT;
        data.startTXT = changeData.startTXT;

        

        let emplType = this.getEmploymentTypeById(changeData.employmentTypeID);
        let bookingStatus = this.getBookingStatusById(changeData.bookingStatusID);
        let label = "?";
        let shortLabel = "";
        let shortLabelCompact = "";
        if (emplType != null) {
            label = this.stringFormat(emplType.mainLabelFormat, emplType.description, data.startTXT, data.endTXT);
            data.ref_type = emplType.ID;
            shortLabel = emplType.code;
        }

        shortLabelCompact = shortLabel;

        //if (this.editor.inputIsOnDuty.getValue() === true) {
        //    //label += "*";
        //    //shortLabelCompact += "*";
        //}

        data.ref_empl_booking_status = bookingStatus?.ID;
        data.mainLabel = label;
        data.shortLabel = shortLabel;
        data.shortLabelCompact = shortLabelCompact;
        data.is_on_duty = changeData.is_on_duty === true;
        data.value1 = "-";
        data.value2 = changeData.pauseTXT;
        data.is_times_confirmed = changeData.is_times_confirmed === true;
        data.mainColorationBG = emplType ? emplType.coloration.BackColor.Hex : "";
        data.mainColorationTXT = emplType ? emplType.coloration.TextColor.Hex : "";
        data.dirty = true;
        data.note_warnings = changeData.warningMessage;
        
        this.applyData(data);
    }

    highlight(): void {
        this.domNode.scrollIntoView({ behavior: "smooth", block: "center" });
        this.UiModder.domClass.add(this.domNode, "highlight");

        setTimeout(lang.hitch(this, this.UiModder.domClass.remove, this.domNode, "highlight" ), 4000);
    }


    postMixInProperties(args?: any): void {
        super.postMixInProperties.apply(this, arguments as any);


        this.windowEx = window as any;
    }

    destroy() {
        if (this.editorActive) {
            this.editor.closeAndSubmit();
        }
        super.destroy.apply(this, arguments as any);
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if (this.virtualID == null) {
            this.virtualID = "virtual-" + Math.random().toString();
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        //this.editor = window.PepEmploymentEditor;
        
        this.applyData();
        this._data.dirty = false;
        this.UiModder.domClass.remove(this.domNode, "changing deleting creating dirty");

        if (this.isVirtual == true) {
            if (this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.brush) {

            } else if (this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.brushCreate) {
                
            }
            else {
                //console.debug("employment opens editor", this._data);
                this.showEditor();
            }
            
        }
    }
}

export default mdsWidget(PepEmployment);